import React from "react";
import { Props as ReactModalProps } from "react-modal";
import icons from "../../icons/icons"
import { Modal } from "./Modal";

import './Link.scss';

interface IProps extends ReactModalProps {
    url: string;
    closeModal: () => void;
    onChangeUrl: (e: React.ChangeEvent<HTMLInputElement>) => void;
    onSaveLink: (e: React.MouseEvent<HTMLButtonElement>) => void;
    onRemoveLink: (e: React.MouseEvent<HTMLButtonElement>) => void;
}

export function LinkModal(props: IProps) {
    const {
        url,
        closeModal,
        onChangeUrl,
        onSaveLink,
        onRemoveLink,
        ...rest
    } = props;

    return (
        <Modal className="link-modal" {...rest}>
            <h2 className="modal-title">Edita l'enllaç</h2>
            <button className="modal-close" type="button" onClick={closeModal}>
                <icons.close />
            </button>
            <input
                className="modal-input"
                autoFocus
                value={url}
                onChange={onChangeUrl}
            />
            <div className="modal-buttons">
                <button className="bt bt-basic" type="button" onClick={onRemoveLink}>
                    Suprimeix
                </button>
                <button className="bt bt-basic bt-basic-vermell" type="button" onClick={onSaveLink}>
                    Desa
                </button>
            </div>
        </Modal>
    );
}
